export type DwellingCost = {
  costingData: DwellingCostResponse;
  cleaningPlans: DwellingCostCleaningPlansResponse;
  costingToolPlans: DwellingCostToolPlansResponse;
  costingToolDilapidations: DwellingCostDilapidationsResponse;
};

export type DwellingCostToolPlansResponse = {
  id: string;
  slug: string;
  label: string;
  equipmentPlans: EquipmentPlan[];
}[];

export type EquipmentPlan = {
  id: string;
  slug: string;
  label: string;
  description: string;
  unit: string;
  preTaxPrice: number;
  taxPercentage: number;
  isDilapidable: false;
};

export type DwellingCostDilapidationsResponse = DwellingCostDilapidation[];

export const CostingToolCleaningPlanAllDwellingSlug = "CTCP_DWELLING";

export type DwellingCostDilapidation = {
  rate: number;
  period: number;
  slug: string;
};

export type DwellingCostCleaningPlansResponse = DwellingCostCleaningPlan[];

export type DwellingCostCleaningPlan = {
  id: string;
  slug: string;
  label: string;
  description: string;
  unit: string;
  preTaxPrice: number;
  taxPercentage: number;
  stringTypes: string;
};

export type DwellingCostResponse = {
  dwelling: Dwelling;
  incomingInventory: Inventory;
  outgoingInventory: Inventory;
  cleanings: CostingCleaning[];
  rooms: Room[];
  key: Room;
  equipment: Room;
  totalCosting: CostingTotal & CostingTotalCleaning;
  version?: {
    web: string;
  };
};

type Dwelling = {
  address: string;
  category: string;
  cleanliness: number;
  door?: string;
  floor: string;
  goodCondition: number;
  isFurnished: boolean;
  lessor: string;
  lotNumber?: string;
  taxNumber?: string;
  occupationPeriod: OccupationPeriod;
  tenants: Tenant[];
  totalCondition: TotalCondition;
  linkVirtualVisit?: string;
  type: string;
};

type Inventory = {
  id: string;
  date: string;
  datedReference: string;
};

type Room = {
  id: string;
  cleaningPlan?: CleaningPlan;
  name: string;
  category: string;
  cleanliness?: number;
  goodCondition?: number;
  totalCleanliness: TotalCleanliness;
  totalCondition: TotalCondition;
  taxAmount: number;
  units: Unit[];
  roomCosting: CostingTotal;
};

type Tenant = {
  fullName: string;
  newAddress: string;
  occupationPeriod: OccupationPeriod;
};

type Unit = {
  isSelected: boolean;
  name: string;
  slug?: string;
  incoming: UnitCondition;
  outgoing: UnitCondition;
  costing: Costing;
};

type UnitCondition = {
  id: string;
  quantity: number;
  observation: string;
  status: string;
  isClean: boolean;
  operatingStatus?: string;
  pictures: string[];
};

export type Costing = {
  plan?: CleaningPlan;
  quantity: number;
  unit: string;
  preTaxPrice: number;
  taxPercentage: number;
  dilapidationPrice: number;
  dilapidation: EquipmentDilapidation;
  taxAmount: number;
  taxIncludedPrice: number;
};

export type CostingCleaning = {
  id: string;
  isSelected: boolean;
  roomName: string;
  plan?: CleaningPlan;
  costing: {
    quantity: number;
    preTaxPrice: number;
    taxPercentage: number;
    taxAmount: number;
    taxIncludedPrice: number;
  };
};

type CostingTotalCleaning = {
  cleaning: {
    preTaxPrice: number;
    taxAmount: number;
    total: number;
  };
};

type TotalCondition = {
  new: Condition;
  good: Condition;
  average: Condition;
  poor: Condition;
  oof: Condition;
};

type TotalCleanliness = {
  clean: Condition;
  dirty: Condition;
  dusty: Condition;
  grease: Condition;
  limestone: Condition;
};

type Condition = {
  number: number;
  percentage: number;
};

type CleaningPlan = {
  id: string;
  label: string;
  slug: string;
  types: string;
  description: string;
  unit: string;
};

type EquipmentDilapidation = {
  id?: string;
  rate: number;
  slug?: string;
};

export type OccupationPeriod = {
  years: number;
  months: number;
  days: number;
};

type CostingTotal = {
  preTaxPrice: number;
  dilapidationDeducted: number;
  taxAmount: number;
  total: number;
};
